/**
 * Plain stroke ✕ / ✓ glyphs for form action buttons (Cancel / Save), matching
 * the Final shell's `CloseX` / `CheckTick`. The icon shim only carries the
 * boxed/circled iconsax variants, so these bare strokes live here.
 */

export function CloseX({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M6 6 18 18M18 6 6 18" />
    </svg>
  );
}

export function CheckTick({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 12.5 10 17.5 19 6.5" />
    </svg>
  );
}
